import { apiClient, API_PRX } from '@indipia/shared';

export interface WorkType {
  workTypeId: number;
  workTypeCode: string;
  workTypeName: string;
  sortOrder: number;
}

export async function fetchWorkTypes(): Promise<WorkType[]> {
  const res = await apiClient.get(`${API_PRX.INDIPIA}/work-types`);
  return res.data.data as WorkType[];
}

export interface CommonCode {
  codeValue: string;
  codeName: string;
}

/** 공통코드 그룹 조회 (예: E01_PARTNER_DEAL_STATUS) */
export async function fetchCommonCodes(codeGroupCode: string): Promise<CommonCode[]> {
  const res = await apiClient.get(`${API_PRX.INDIPIA}/codes`, { params: { codeGroupCode } });
  return (res.data.data ?? []) as CommonCode[];
}

/** 배송지역 시군구 (코드 + 표시명) */
export interface VendorSigungu {
  sigunguCode: string;
  sigunguName: string;
}

export async function createVendor(payload: {
  vendorTypeCode: string;
  vendorName: string;
  vendorPhone: string;
  contactName?: string | null;
  vendorBizNo?: string | null;
  vendorRepName?: string | null;
  vendorEmail?: string | null;
  dealStatus?: string | null;
  commYn?: string;
  workTypes?: string[];
  dealItem?: string | null;
  sigungus?: VendorSigungu[];
  vendorMemo?: string | null;
}): Promise<number> {
  // 자재거래처→시공파트너 원장 통합: 자재파트너는 /member/partners(partnerRole=MATERIAL)로 등록된다.
  const res = await apiClient.post(`${API_PRX.MEMBER}/partners`, {
    partnerName: payload.vendorName,
    mobile: payload.vendorPhone,
    email: payload.vendorEmail,
    partnerRole: 'MATERIAL',
    contactName: payload.contactName,
    dealItem: payload.dealItem,
    dealStatus: payload.dealStatus,
    commYn: payload.commYn,
    subWorkTypes: payload.workTypes,
    sigungus: payload.sigungus?.map((s) => ({ code: s.sigunguCode, name: s.sigunguName })),
    partnerBizYn: 'Y',
    partnerBizNo: payload.vendorBizNo,
    partnerBizName: payload.vendorName,
    partnerRepName: payload.vendorRepName,
    memo: payload.vendorMemo,
  });
  return res.data.data.partner_id as number;
}

/** 중복 확인 — 사업자번호(vendorBizNo) 기준. 자재파트너는 항상 사업자 */
export async function checkVendorExists(vendorBizNo: string): Promise<boolean> {
  const res = await apiClient.get(`${API_PRX.MEMBER}/partners/exists`, {
    params: { partnerBizNo: vendorBizNo },
  });
  return (res.data.data?.exists ?? false) as boolean;
}
